export const createDcChargingPercentageValidator = (isFirst, isLast, prevPercentage) => {
    return {
        validator(_, value) {
            if (value === undefined)
                return Promise.resolve();
            // Первая точка должна быть 0%
            if (isFirst && value !== 0) {
                return Promise.reject(new Error("Первая точка должна быть 0%"));
            }
            // Последняя точка должна быть 100%
            if (isLast && value !== 100) {
                return Promise.reject(new Error("Последняя точка должна быть 100%"));
            }
            // Промежуточные точки должны быть больше предыдущей
            if (!isFirst && !isLast && value < prevPercentage) {
                return Promise.reject(new Error(`Не меньше ${prevPercentage}%`));
            }
            if (value > 100) {
                return Promise.reject(new Error("Не больше 100%"));
            }
            if (value < 0) {
                return Promise.reject(new Error("Не меньше 0%"));
            }
            return Promise.resolve();
        },
    };
};
const EPS = 0.0001;
export const makeDefaultCurve = (maxPower) => [
    { percentage: 0, power: 0 },
    { percentage: 10, power: maxPower },
    { percentage: 60, power: Math.round(maxPower * 0.95 * 100) / 100 },
    { percentage: 80, power: Math.round(maxPower * 0.6 * 100) / 100 },
    { percentage: 100, power: Math.round(maxPower * 0.2 * 100) / 100 },
];
export const isDefaultDcCurve = (curve, maxPower) => {
    if (!maxPower)
        return false;
    if (!curve || curve.length !== 5)
        return false;
    const def = makeDefaultCurve(maxPower);
    const eq = (a, b) => Math.abs(a - b) < EPS;
    // сравним поэлементно
    return curve.every((item, index) => {
        const d = def[index];
        return item.percentage === d.percentage && eq(item.power, d.power);
    });
};
